import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import { addTransportQuotations } from "./TransportQuotations.slice";

import getTransportQuotationsAPI from "./TransportQuotations.api";

export const ADD_TRANSPORT_QUOTATIONS = {
  LOADING: "ADD_TRANSPORT_QUOTATIONS_LOADING",
  SUCCESS: "ADD_TRANSPORT_QUOTATIONS_SUCCESS",
  ERROR: "ADD_TRANSPORT_QUOTATIONS_FAILURE",
};

function* getTransportQuotations(action) {
  const { payload } = action;

  try {
    const data = yield call(getTransportQuotationsAPI, payload);
    yield put(addTransportQuotations(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: ADD_TRANSPORT_QUOTATIONS.ERROR, error });
  }
}

export default function* getTransportQuotationsSaga() {
  yield takeLatest(ADD_TRANSPORT_QUOTATIONS.LOADING, getTransportQuotations);
}
